<template>
  <div class="mb-4 chart-info">
    <button class="btn btn-outline-secondary" @click="toggle()">
      <strong>{{ trigger }}</strong>
    </button>

    <div class="mt-2">
      <collapsible :collapsed="collapsed">
        <dl>
          <dt>Long-distance mobility</dt>
          <dd class="shown">
            Long-distance mobility measures the number of countries passed
            through on the way to the current location.
          </dd>
          <div class="hidden">
            4.2.5 - On your way to your current place of living, in how many
            countries did you live or pass through?
          </div>

          <dt>Internal mobility</dt>
          <dd class="shown">
            Internal mobility combines two questions and measures the number of
            places within the study country at which respondents have lived and their
            freedom to move around in the study country.
          </dd>
          <div class="hidden">
            4.4.1 - In which cities/places have you lived in this country since
            leaving your home and before coming to this place? <br />
            4.4.2 - Do you experience any restrictions in moving freely around
            within the country you now live in?
          </div>

          <dt>Return mobility</dt>
          <dd class="shown">
            Return Mobility measures if and if yes how often respondents have
            returned to their home country or former place of living.
          </dd>
          <div class="hidden">
            4.5.1 - Since the initial displacement from your home, have you
            returned there? <br />
            4.5.2 - How many times have you returned there?
          </div>

          <dt>Return intention</dt>
          <dd class="shown">
            Return intention measures the respondents' intentions to return home or
            to their former place of living.
          </dd>
          <div class="hidden">
            4.5.4 - Do you intend to return to your home/place of former living
            within the next two years?
          </div>

          <dt>Onward move attempts</dt>
          <dd class="shown">
            Onward move attempts measures the respondents' past attempts to move to
            another place or country.
          </dd>
          <div class="hidden">
            4.6.1 - Since you have been living here, how many times have you
            tried to visit or move to another country?
          </div>

          <dt>Onward move intention</dt>
          <dd class="shown">
            Onward move intention measures the respondents' intentions to move to
            another country or place in the future.
          </dd>
          <div class="hidden">
            4.6.4 - Do you intend to move to another place or country to live
            there in the future?
          </div>

          <dt>Freedom to move on</dt>
          <dd class="shown">
            Freedom to move on combines two questions and measures if and
            if yes to what extent there are reasons hindering the respondents to
            move to another country. A higher value indicates more freedom and 
            less barriers to move on.
          </dd>
          <div class="hidden">
            4.6.7 - Are there any reasons why you can not move to another
            country? <br />
            4.6.8 - What hinders you from moving on to another country?
          </div>

          <dt>Resettlement/Relocation</dt>
          <dd class="shown">
            Resettlement/Relocation combines two questions and measures the
            respondents' access to resettlement/relocation and their application 
            status if they have been suggested or applied for it previously.
          </dd>
          <div class="hidden">
            4.6.9a - Have you ever applied or been suggested for resettlement or
            relocation to another country? <br />
            4.6.9c - What is the status of your resettlement or relocation
            application?
          </div>
        </dl>
      </collapsible>
    </div>
  </div>
</template>

<style scoped>
/*
    .chart-info {
        font-size: 80%;
    }
    */
dl dd + dt {
  margin-top: 0.5rem;
}
dl dd {
  padding-left: 2em;
  opacity: 0.6;
}

dl dt {
  color: #71797E;
}

dd:hover {
  font-weight: bold;
}

.hidden {
  font-size: 0%;
  transition-property: font-size;
  transition-duration: .9s;
}

.shown:hover + .hidden {
  display: block;
  color: #ec773b;
  font-style: italic;
  padding-left: 2em;
  margin-top: 0.5em;
  margin-bottom: 1.5em;
  outline: 2px dotted #71797e;
  font-size: 100%;
}
</style>

<script>
import Collapsible from "./CollapsibleScale.vue";

export default {
  components: {
    Collapsible,
  },
  data() {
    return {
      collapsed: true,
    };
  },
  computed: {
    trigger() {
      return this.collapsed
        ? "Show indicator details"
        : "Hide indicator details or hover to see questions";
    },
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>
